export default {"src":"/_next/static/media/icon_check.3efcf0a8.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};